import React, { Suspense, lazy } from "react";

// Keep this wrapper tiny; lazy-load the heavy app tree
const RootApp = lazy(() => import("./RootApp"));

const AtunwaPlayer = ({ dev }: { dev?: boolean }) => (
  <React.StrictMode>
    <Suspense fallback={null}>
      <RootApp dev={dev} />
    </Suspense>
  </React.StrictMode>
);

export default AtunwaPlayer;
